import { formatCatalogAmount } from "@/lib/landingCatalogCopy";

export const PRICING_FALLBACK_AMOUNT = "$299";

export const PRICING = {
  badge: "TRANSPARENT VALUE & PRICING",
  headlineLead: "A Full-Time Roofing Sales Employee for",
  headlineAccent: "10%",
  headlineTail: "of the Cost.",
  subhead:
    "No benefits, no commissions, no sick leave. Just 24/7/365 instant lead interception and calendar booking.",
  tierTitle: "Roofing Digital Employee Tier",
  priceNote: "after 14-day free trial",
  features: [
    "26-Second Speed-to-Lead Guarantee across SMS, Web, Meta & WhatsApp",
    "100% Roofing-Specific Qualification Logic (Shingles, Tile, Leaks, Insurance)",
    "Direct Calendar Booking Sync (GoHighLevel / Google Calendar / CRM)",
    "Unlimited Lead Interceptions with zero per-lead markups",
    "12-Minute Concierge Setup by our technical team",
  ],
  mathTitle: "MATH ON INVESTMENT:",
  mathHuman: {
    icon: "👤",
    label: "Human After-Hours Sales Rep",
    value: "~$3,500/mo + commissions + training",
  },
  mathEmployee: {
    icon: "🤖",
    label: "Roofing Digital Employee",
    valueSuffix: "(Less than 10% of a human salary)",
  },
  mathRoi: {
    icon: "💰",
    label: "ROI Anchor",
    value:
      "Just 1 saved estimate replacement ($12,000 avg ticket) pays for the entire year of software.",
  },
  cta: "Put Your Digital Employee to Work — 14 Days Free",
  disclosure: "No credit card required to start • Cancel anytime in 1 click",
  conciergeNote:
    "Don't want to touch webhooks or integrations yourself? Our technical team configures your response rules and calendar sync for you in 12 minutes during your free trial.",
};

export function pricingAmountLabel(entryOffer) {
  if (entryOffer?.amount_minor != null && entryOffer?.currency) {
    return formatCatalogAmount(entryOffer.amount_minor, entryOffer.currency);
  }
  return PRICING_FALLBACK_AMOUNT;
}
